export const set_seen = () => ({
  type: "SET_SEEN",
});

export const set_carwash_visible = (status) => ({
  type: "SET_CARWASH_VISIBLE",
  payload: status,
});

export const set_carwash_expanded = (status) => ({
  type: "SET_CARWASH_EXPANDED",
  payload: status,
});
